import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Terms of Service</h1>
      <p style={styles.updated}>Last updated: June 25, 2026</p>

      <section style={styles.section}>
        <h2 style={styles.heading}>1. About Moa</h2>
        <p style={styles.paragraph}>
          Moa ("we", "us", or "our"), operated at moashops.com, is a proxy-purchase and goods
          resale service. We help overseas customers obtain Korean goods that are otherwise hard to
          buy directly: we purchase items on your behalf (our "proxy purchase" / 대리구매 service),
          consolidate them, and ship them to you. By creating an account or placing an order you
          agree to these Terms.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>2. Orders and Payment</h2>
        <p style={styles.paragraph}>
          Orders may be placed through our group-buy listings or through a proxy-purchase request.
          Payments are processed by our payment providers (PayPal and, where available, card). For
          proxy purchases, the final amount may include the item price, domestic and international
          shipping, and service fees. If the actual cost differs from the initial quote, we may
          issue an additional charge, which you can review and pay before we ship.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>3. Shipping and Customs</h2>
        <p style={styles.paragraph}>
          Items are shipped internationally. Delivery times are estimates and may vary. You are
          responsible for any customs duties, taxes, or import fees charged by your country. Please
          make sure your shipping address and contact details are accurate before checkout.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>4. Damaged or Lost Items</h2>
        <p style={styles.paragraph}>
          If your item arrives damaged, please email us at support@moashops.com with a description
          of the case and, if possible, photos of the damage and the packaging. We also recommend
          filing an inquiry with the delivery carrier that handled your parcel. Once you have
          contacted the carrier, let us know, and after we check the details we will do our best to
          explore ways to help resolve the issue with you. As an intermediary we cannot guarantee a
          specific outcome, but we are committed to supporting you through the process.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>5. Cancellations and Refunds</h2>
        <p style={styles.paragraph}>
          Orders may be cancelled before they enter preparation. Once an order is being prepared,
          shipped, or delivered, it can no longer be cancelled. For proxy purchases, cancellation
          may not be possible once we have already bought the item on your behalf. Refunds, where
          applicable, are returned through the original payment method.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>6. Governing Law</h2>
        <p style={styles.paragraph}>
          These Terms are governed by the laws of the Republic of Korea, without regard to conflict
          of law principles.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>7. Contact</h2>
        <p style={styles.paragraph}>
          Moa is an individually operated service. For any questions about these Terms, contact us
          at support@moashops.com.
        </p>
      </section>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 800, margin: '60px auto', padding: '0 20px 120px' },
  title: { fontSize: 26, fontWeight: 700, color: '#333', marginBottom: 8 },
  updated: { fontSize: 13, color: '#aaa', marginBottom: 40, paddingBottom: 16, borderBottom: '2px solid #f0f0f0' },
  section: { marginBottom: 32 },
  heading: { fontSize: 17, fontWeight: 700, color: '#444', marginBottom: 12 },
  paragraph: { fontSize: 14, lineHeight: 1.8, color: '#555' },
};

export default TermsPage;
